const CODE_MAX_LENGTH = 50
const REQUIRED_MESSAGE = "Code is required"
const TOO_LONG_MESSAGE = `Code must be ${CODE_MAX_LENGTH} characters or fewer`

// Trims accidental leading/trailing whitespace (including non-breaking spaces the browser
// substitutes in for repeated keystrokes) — never touches meaningful content in the middle.
export function trimCode(code) {
    if (typeof code !== "string") return code
    return code.trim()
}

// The code field is single-line, but contentEditable's default Enter behavior inserts a literal
// newline into the value. Callers should call preventDefault() on the keydown when this is true.
export function shouldBlockCodeEnterKey({ key }) {
    return key === "Enter"
}

// The message shown under the field: required and too-long take priority over the live
// duplicate-code check, since those are checkable instantly without a server round-trip.
export function resolveCodeDisplayError({ code, duplicateError }) {
    const trimmed = code?.trim() ?? ""
    if (!trimmed) return REQUIRED_MESSAGE
    if (trimmed.length > CODE_MAX_LENGTH) return TOO_LONG_MESSAGE
    return duplicateError ?? null
}

// Same priority as resolveCodeDisplayError, as a boolean — feeds ScheduleCodeAvailabilityChanged,
// which keeps Submit For Review disabled while any of these hold.
export function isCodeUnavailable({ code, duplicateUnavailable }) {
    const trimmed = code?.trim() ?? ""
    return Boolean(duplicateUnavailable) || !trimmed || trimmed.length > CODE_MAX_LENGTH
}
